import React, { useEffect, useState } from "react";
import { Link, NavLink, useSearchParams } from "react-router-dom";
import "./LandingPage.css"; // Reuse the landing background and shared styles

const ThankYouPage = () => {
  const [searchParams] = useSearchParams();
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const paymentMethod = searchParams.get("method") || "unknown";
  const tier = searchParams.get("tier") || "subscription";
  const amount = searchParams.get("amount");

  useEffect(() => {
    // Track conversion event for Google Analytics
    if (window.gtag) {
      window.gtag("event", "purchase", {
        transaction_id:
          searchParams.get("transaction_id") ||
          searchParams.get("subscription_id") ||
          Date.now().toString(),
        value: amount ? parseFloat(amount) : 0,
        currency: "USD",
        payment_method: paymentMethod,
        subscription_tier: tier,
        event_category: "ecommerce",
        event_label: `${paymentMethod}_${tier}`,
      });

      // Track Google Ads conversion
      window.gtag("event", "conversion", {
        send_to: "G-SB327F57FD",
        value: amount ? parseFloat(amount) : 0,
        currency: "USD",
        transaction_id:
          searchParams.get("subscription_id") || Date.now().toString(),
      });

      // Google Ads Purchase Conversion Event
      window.gtag("event", "conversion_event_purchase", {
        // Add any additional parameters here if needed
      });
    }

    // Track page view
    if (window.gtag) {
      window.gtag("config", "G-SB327F57FD", {
        page_title: "Thank You - Purchase Complete",
        page_location: window.location.href,
      });
    }
  }, [searchParams, paymentMethod, tier, amount]);

  return (
    <div className="landing-container thank-you-page">
      {/* Navigation Header */}
      <nav className="navigation-header">
        <div className="nav-links">
          <Link to="/" className="nav-link">
            Home
          </Link>
          <Link to="/pricing" className="nav-link">
            Pricing
          </Link>
          <div
            className="nav-item dropdown"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <NavLink to="/knn" className="nav-link">
              Keisha News Network (KNN)
            </NavLink>
            {isDropdownOpen && (
              <div className="dropdown-menu">
                <Link to="/bias-detection" className="dropdown-item">
                  Fragile News Decoder
                </Link>
                <a
                  href="https://maga.talk2keisha.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="dropdown-item"
                >
                  The MAGA Files
                </a>
                <a
                  href="https://fnsnews.talk2keisha.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="dropdown-item"
                >
                  FNS (Fragile News Source) beta
                </a>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* Google Ads Conversion Tracking */}
      <script
        dangerouslySetInnerHTML={{
          __html: `
          <!-- Google tag (gtag.js) event -->
          gtag('event', 'conversion_event_purchase', {
            // <event_parameters>
          });
        `,
        }}
      />

      {/* Thank You Content */}
      <div
        className="hero-section"
        style={{ paddingTop: "140px", minHeight: "100vh" }}
      >
        <div
          className="hero-content"
          style={{ textAlign: "center", maxWidth: "700px", margin: "0 auto" }}
        >
          <div
            style={{
              fontSize: "4rem",
              marginBottom: "1.5rem",
              background: "linear-gradient(45deg, #00ffff, #00ff88)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            🔥
          </div>

          <h1
            style={{
              marginBottom: "1.5rem",
              background: "linear-gradient(45deg, #00ffff, #00ff88)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              fontSize: "2.5rem",
            }}
          >
            Welcome to the Resistance!
          </h1>

          <p
            style={{
              fontSize: "1.3rem",
              marginBottom: "2.5rem",
              color: "#00ffff",
              lineHeight: "1.6",
            }}
          >
            Your subscription is active. You're now equipped to attack the
            firewall of white fragility that protects the operating system of
            white supremacy.
          </p>

          <div
            style={{
              background: "rgba(255, 0, 255, 0.1)",
              border: "2px solid rgba(255, 0, 255, 0.4)",
              borderRadius: "20px",
              padding: "2.5rem",
              marginBottom: "2.5rem",
              boxShadow: "0 0 20px rgba(255, 0, 255, 0.2)",
            }}
          >
            <h2
              style={{
                color: "#ff00ff",
                marginBottom: "1.5rem",
                fontSize: "1.8rem",
              }}
            >
              Your Mission Begins Now
            </h2>
            <div
              style={{
                color: "#ffffff",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                textAlign: "left",
              }}
            >
              <p>
                🎯 <strong>Decode the lies</strong> - Every biased article you
                analyze weakens their narrative
              </p>
              <p>
                🔍 <strong>See through the matrix</strong> - Expose the hidden
                racism in "neutral" news
              </p>
              <p>
                💪 <strong>Build resistance</strong> - Share your insights, wake
                up others
              </p>
              <p>
                📰 <strong>Stay informed</strong> - The "Dismantled" newsletter
                will keep you sharp
              </p>
            </div>
          </div>

          <div
            style={{
              background: "rgba(0, 255, 136, 0.1)",
              border: "1px solid rgba(0, 255, 136, 0.3)",
              borderRadius: "15px",
              padding: "2rem",
              marginBottom: "2.5rem",
            }}
          >
            <h3
              style={{
                color: "#00ff88",
                marginBottom: "1rem",
                fontSize: "1.5rem",
              }}
            >
              Ready to Fight Back?
            </h3>
            <p
              style={{
                color: "#ffffff",
                fontSize: "1.1rem",
                lineHeight: "1.6",
                marginBottom: "1.5rem",
              }}
            >
              The system depends on your ignorance. Every article you decode is
              an act of rebellion.
            </p>
          </div>

          <div
            style={{
              display: "flex",
              gap: "1.5rem",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Link
              to="/bias-detection"
              className="cta-button"
              style={{
                background: "linear-gradient(45deg, #ff00ff, #00ffff)",
                color: "#000000",
                textDecoration: "none",
                padding: "15px 30px",
                borderRadius: "12px",
                fontWeight: "bold",
                fontSize: "1.1rem",
                transition: "all 0.3s ease",
                boxShadow: "0 0 15px rgba(255, 0, 255, 0.4)",
              }}
            >
              🔥 Start Decoding Now
            </Link>
          </div>

          <div
            style={{
              marginTop: "3rem",
              padding: "1.5rem",
              background: "rgba(0, 0, 0, 0.4)",
              borderRadius: "15px",
              fontSize: "1rem",
              color: "#cccccc",
              border: "1px solid rgba(255, 255, 255, 0.1)",
            }}
          >
            <p style={{ marginBottom: "0.5rem" }}>
              Questions? Contact us at{" "}
              <a
                href="mailto:support@talk2keisha.com"
                style={{ color: "#00ffff" }}
              >
                support@talk2keisha.com
              </a>
            </p>
            <p style={{ marginBottom: "0" }}>
              Follow the resistance:{" "}
              <a
                href="https://x.com/AI_Keisha"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#ff00ff" }}
              >
                @AI_Keisha
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
